import moment from 'moment';
import { paymentPlansApi } from './api';
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import formMixin from '../shared/vue/mixins/form';
import multistepMixin from '../shared/vue/mixins/multistep';
import { formatBasicCurrency } from '../shared/utils/misc';
import dataLayerPush from '../shared/utils/analytics';

/**
 * Enrolling in promise to pay
 */
export default function promiseToPay() {
  const el = select('[data-vue-app="promise-to-pay"]');

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [formMixin, multistepMixin],
      data: {
        agree: false,
        error: false,
        isReady: false,
        success: false,
        errorMessage: null,
        // promise to pay details
        accountId: '',
        currentDate: moment().format("MM/DD/YYYY"),
        shutOffAmount: '',
        promiseDate: '',
        currentBalance: '',
        // set these to pass during enrollment
        initialPaymentAmount: '',
        initialPaymentDueDate: '',
        paymentFrequencyOptions: '',
        // for accessibility in live regions
        liveText: '',
      },
      computed: {
        enrollmentDataStructure() {
          return {
            planId: 'N',
            initialPaymentAmount: parseFloat(this.initialPaymentAmount.replace(/[^0-9-.]/g, '')),
            initialPaymentDueDate: this.initialPaymentDueDate,
            termPeriodMonths: this.paymentFrequencyOptions[0].termPeriodMonths,
            monthlyPayment: this.paymentFrequencyOptions[0].paymentAmount,
            totalAgreementAmount: parseFloat(this.initialPaymentAmount.replace(/[^0-9-.]/g, '')),
          }
        },
      },
      watch: {
        step(newVal, oldVal) { // eslint-disable-line no-unused-vars
          /**
           * Changes live text depending on the form step
           */
          if (this.step === 2) {
            this.liveText = 'Moving to Step 2 to verify your promise to pay details';
          } else if (this.step === 1) {
            this.liveText = 'You are now back on Step 1 to review your promse to pay terms and details';
          }
        },
      },
      mounted() {
        this.loading = true;
        this.shutOffAmount = (this.$el.dataset && this.$el.dataset.shutOffAmount) ? formatBasicCurrency(this.$el.dataset.shutOffAmount) : '';
        Vue.nextTick(() => {
          // get the plan selected
          this.getPromiseToPayDetails();
        });
      },
      /**
       * Methods
       */
      methods: {
        // call to enroll the user in promise to pay
        submitPromiseToPay() {
          this.loading = true;
          const enrollmentData = this.enrollmentDataStructure;
          paymentPlansApi.enrollInPaymentPlan(enrollmentData)
            .then(() => {
              this.loading = false;
              this.setStep(4);
              this.success = true;
              dataLayerPush('PromiseToPay');
            })
            .catch(() => {
              this.loading = false;
              this.setStep(4);
              this.error = true;
            });
        },
        // get the plan details from the API
        getPromiseToPayDetails() {
          paymentPlansApi.getPlanDetail('N')
            .then((response) => {
              this.accountId = response.data.accountId;
              this.currentBalance = formatBasicCurrency(response.data.currentBalance);
              this.initialPaymentAmount = formatBasicCurrency(response.data.initialPaymentAmount);
              this.initialPaymentDueDate = response.data.initialPaymentDueDate;
              this.promiseDate = moment(response.data.initialPaymentDueDate).format("MM/DD/YYYY");
              this.paymentFrequencyOptions = response.data.frequencyOptions;
              this.loading = false;
              // app is ready when the details are there
              this.isReady = true;
            });
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/promiseToPay.js